import { cva } from '@/styled-system/css';

export const alertBodyRecipe = cva({
  base: {
    flex: '1',
    textStyle: 'body',
  },
  variants: {
    tone: {
      critical: { color: 'Alert.critical.text' },
      info: { color: 'Alert.info.text' },
      success: { color: 'Alert.success.text' },
      warning: { color: 'Alert.warning.text' },
    },
  },
});
